import classNames from 'classnames';
import { parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import Button from '../../buttons/Button';

import styles from '../../../../styles/items/games/nfl.module.scss';

const propTypes = {
    className: PropTypes.string,
    game: AppPropTypes.game,
    participation: AppPropTypes.participation,
    canParticipate: PropTypes.bool,
};

const defaultProps = {
    className: null,
    game: null,
    participation: null,
    canParticipate: true,
};

function NflGameItem({ className, game, participation, canParticipate }) {
    const themeClassName = useThemeClassName(styles);
    const { sportGame, url } = game || {};
    const { teamAway, teamHome, startAt, isEnded = false, isStarted = false } = sportGame || {};
    const { location: teamAwayLocation } = teamAway || {};
    const { ended: participationEnded = false, points = null } = participation || {};
    const { location: teamHomeLocation } = teamHome || {};
    const startAtDate = useMemo(() => parseISO(startAt), [startAt]);

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.active]: participation !== null,
                    [styles.canParticipate]: canParticipate,
                    [styles.ended]: isEnded,
                },
                themeClassName,
                className,
            ])}
            href={canParticipate ? url : null}
            disabled={!canParticipate}
        >
            <span className={styles.content}>
                <h2 className={styles.label}>
                    <span className={styles.teamAway}>
                        <span className={styles.name}>{teamAwayLocation}</span>
                    </span>
                    <span className={styles.teamHome}>
                        <span className={styles.vs}>
                            <FormattedMessage defaultMessage="VS" description="NHL versus label" />{' '}
                        </span>
                        <span className={styles.name}>{teamHomeLocation}</span>
                    </span>
                </h2>
                {points !== null && participationEnded ? (
                    <span className={styles.points}>
                        <FormattedMessage
                            defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts}}"
                            description="pts label"
                            values={{ count: points || 0 }}
                        />
                    </span>
                ) : null}
                <span className={styles.startAt}>
                    {isEnded || isStarted ? (
                        <span className={styles.status}>
                            {isEnded ? (
                                <FormattedMessage
                                    defaultMessage="Ended"
                                    description="Sport game status"
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Live"
                                    description="Sport game status"
                                />
                            )}
                        </span>
                    ) : null}

                    <span className={styles.date}>
                        <FormattedDate
                            value={startAt}
                            day="2-digit"
                            month="short"
                            weekday="short"
                        />
                    </span>
                    <FormattedDate value={startAtDate} hour="numeric" minute="numeric" />
                </span>
            </span>
            {/* {!isEnded ? (
                <span className={styles.endedLabel}>
                    <FormattedMessage defaultMessage="Game played" description="Game played" />
                </span>
            ) : null} */}
        </Button>
    );
}

NflGameItem.propTypes = propTypes;
NflGameItem.defaultProps = defaultProps;

export default NflGameItem;
